//@flow
import {type StoreState} from '$src/state/types'
import {type ClientNamespaceState} from '$src/client/types'

export const selectClient: (state: StoreState) => ClientNamespaceState = (state) => state.client



// WEBPACK FOOTER //
// ./src/client/selectors.js